import { render } from "./TianDiTuMap.vue?vue&type=template&id=0b2c8dd2&scoped=true"
import script from "./TianDiTuMap.vue?vue&type=script&lang=js"
export * from "./TianDiTuMap.vue?vue&type=script&lang=js"

import "./TianDiTuMap.vue?vue&type=style&index=0&id=0b2c8dd2&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0b2c8dd2"]])

export default __exports__